export default __webpack_public_path__ + "static/media/artboard2.1096a7e6.png";